import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ServicePathsSettings } from '../configuration/service-paths-settings';

@Injectable({
  providedIn: 'root'
})
export class UfficiService {
    constructor(
      private http: HttpClient
    ) { }
    
  getAllOfficeTypes(filterValue: string): Observable<any> {
    const mockData = {
      items : [
        { idUo: "1", description: 'Ufficio delle Dogane di MESSINA', label: 'Ufficio delle Dogane di MESSINA' },
        { idUo: "2", description: 'Ufficio delle Dogane di BARI' , label: 'Ufficio delle Dogane di BARI'},
        { idUo: "3", description: 'Ufficio delle Dogane di NAPOLI' , label: 'Ufficio delle Dogane di NAPOLI'},
        { idUo: "4", description: 'Ufficio delle Dogane di CATANZARO' , label: 'Ufficio delle Dogane di CATANZARO'},
        { idUo: "5", description: 'Ufficio delle Dogane di BRINDISI' , label: 'Ufficio delle Dogane di BRINDISI'},
        { idUo: "6", description: 'Ufficio delle Dogane di MATERA' , label: 'Ufficio delle Dogane di MATERA'},
        { idUo: "7", description: 'Ufficio delle Dogane di POTENZA', label: 'Ufficio delle Dogane di POTENZA' },
        { idUo: "8", description: 'Ufficio delle Dogane di BARI SARDO' , label: 'Ufficio delle Dogane di BARI SARDO'},
        { idUo: "9", description: 'Ufficio delle Dogane di MILAZZO', label: 'Ufficio delle Dogane di MILAZZO' },
        { idUo: "10", description: 'Ufficio delle Dogane di MILANO' , label: 'Ufficio delle Dogane di MILANO'},
      ]
    };    
    const filteredData = mockData.items.filter(item => item.description.toLowerCase().includes(filterValue.toLowerCase()));
    mockData.items = filteredData
    return of(mockData);
  }

  getUffici(nomeUfficio: string): Observable<any> {
    let url = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + '/gp/protocols/offices/'+ nomeUfficio;
    return this.http.get<any>(url);
  }
}

export interface Uffici {
  idUo: string;
  description: string;
  label: string;
}
